<div class="card" [@focusShadow]="(isCollapsed$ | async)?'blur':'focus'">
  <ds-truncatable [id]="dso.id">
    <div class="position-absolute ml-1">
      <ng-content></ng-content>
    </div>
    <a *ngIf="linkType !== linkTypes.None"
       [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'"
       [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null" [routerLink]="[itemPageRoute]"
       class="card-img-top full-width" tabindex="-1" [attr.title]="'search.results.view-result' | translate" role="link" tabindex="0">
      <div>
        <ds-thumbnail [thumbnail]="dso?.thumbnail | async" [limitWidth]="false">
        </ds-thumbnail>
      </div>
    </a>
    <span *ngIf="linkType === linkTypes.None" class="card-img-top full-width">
            <div>
                <ds-thumbnail [thumbnail]="dso?.thumbnail | async" [limitWidth]="false">
                </ds-thumbnail>
            </div>
        </span>
    <div class="card-body">
      <ds-badges *ngIf="showLabel" [object]="dso" [context]="context"></ds-badges>
      <ds-truncatable-part [id]="dso.id" [minLines]="3" type="h4">
        <h4 class="card-title" [innerHTML]="dsoTitle"></h4>
      </ds-truncatable-part>
      <p *ngIf="dso.hasMetadata('creativework.datePublished')"
         class="item-date card-text text-muted">
        <ds-truncatable-part [id]="dso.id" [minLines]="1">
          <span [innerHTML]="firstMetadataValue('creativework.datePublished')"></span>
        </ds-truncatable-part>
      </p>
      <p *ngIf="dso.hasMetadata('journal.title')" class="item-journal-title card-text">
        <ds-truncatable-part [id]="dso.id" [minLines]="3">
          <span [innerHTML]="firstMetadataValue('journal.title')"></span>
        </ds-truncatable-part>
      </p>
      <div *ngIf="linkType !== linkTypes.None" class="text-center">
        <a [target]="(linkType === linkTypes.ExternalLink) ? '_blank' : '_self'"
           [attr.rel]="(linkType === linkTypes.ExternalLink) ? 'noopener noreferrer' : null" [routerLink]="[itemPageRoute]"
           class="lead btn btn-primary viewButton" role="link" tabindex="0">{{ 'search.results.view-result' | translate}}</a>
      </div>
    </div>
  </ds-truncatable>
  <ng-content></ng-content>
</div>
